module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/oj-e79254b0.webp";